import React, { useState } from "react";
import { Controller } from "react-hook-form";
import get from "lodash/get";
import { StyledInput } from "./InputPassword.style";
import clsx from "clsx";
import InputMask from "react-input-mask";
import { IconButton } from "src/components/ui/baseButton";

const InputPassword = (props, ref) => {
  const { name, control, normalizes, mask, className, ...rest } = props;

  const [showPassword, setShowPassword] = useState(false);

  const onChangeHandler =
    ({ onChange }) =>
    (e) => {
      const val = e.target.value;
      const isPassRule =
        (normalizes && normalizes.every((normalize) => normalize(val))) ?? true;
      if (val && !isPassRule) {
        return;
      }
      onChange(val);
    };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: { errors } }) => {
        const errorMsg = get(errors, `${name}.message`, undefined);

        return (
          <>
            <div className="relative">
              <InputMask
                mask={mask}
                value={field.value}
                onChange={onChangeHandler({ onChange: field.onChange })}
                className={`${className} ${clsx({
                  "border-vekin-red100": Boolean(errorMsg),
                })}`}
                type={showPassword ? "text" : "password"}
                {...rest}
              >
                <StyledInput
                  name={field.name}
                  // ref={null}
                />
              </InputMask>

              <div className="absolute top-3 right-2">
                <IconButton
                  className={""}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={
                      !showPassword ? "ri-eye-off-line" : "ri-eye-line"
                    }
                  />
                </IconButton>
              </div>
            </div>

            {errorMsg ? (
              <label className="label !py-1 text-vekin-message-error">
                <span className="label-text-alt text-vekin-message-error">
                  {errorMsg}
                </span>
              </label>
            ) : null}
          </>
        );
      }}
    />
  );
};

InputPassword.displayName = "Input";

export default InputPassword;
